/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBrush: {
  name: 'brush';
  data: string;
} = {
  name: 'brush',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.646 2.06a.5.5 0 0 1 .707 0l.586.586a.5.5 0 0 1 0 .708L7.9 9.392A4.02 4.02 0 0 0 6.608 8.1l6.038-6.04ZM5.631 7.663a.509.509 0 0 1 .015-.016l6.293-6.292a1.5 1.5 0 0 1 2.122 0l.585.585a1.5 1.5 0 0 1 0 2.122l-6.292 6.293a.481.481 0 0 1-.016.015A4 4 0 0 1 4.5 15.5H2A1.5 1.5 0 0 1 .5 14v-2.5a4 4 0 0 1 5.131-3.838ZM1.5 11.5a3 3 0 1 1 3 3H2a.5.5 0 0 1-.5-.5v-2.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
